import React from 'react';
import { useServicesStatus } from '../../customHooks/useServicesStatus';
import Loading from '../Loading';

export const HealthCheckError = ({ children }) => {
  const { servicesStatus, isLoading, hasOfflineServices } = useServicesStatus();

  // Mostrar spinner de carga si está cargando o si hay servicios offline
  const shouldShowLoading = isLoading || hasOfflineServices;

  return (
    <div className="container" style={{'minHeight': 'calc(100vh - 190px)'}}>
      {shouldShowLoading ? (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh'
        }}>
          <Loading />
        </div>
      ) : (
        children
      )}
    </div>
  );
}; 